import { render, staticRenderFns } from "./Folder.vue?vue&type=template&id=35a85bd8&scoped=true&"
import script from "./Folder.vue?vue&type=script&lang=js&"
export * from "./Folder.vue?vue&type=script&lang=js&"
import style0 from "./Folder.vue?vue&type=style&index=0&id=35a85bd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a85bd8",
  null
  
)

component.options.__file = "Folder.vue"
export default component.exports